import { useContext, useState } from 'react';
import {
  Container,
  Dialog,
  DialogContent,
  DialogActions,
  Button
} from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material';
import SettingsList from '../components/SettingsList';
import SettingsItem from '../components/SettingsItem';
import StoreContext from '../context/StoreContext';

const Settings = () => {

  const { storeList } = useContext(StoreContext);

  const [showList, setShowList] = useState(true);
  const [settingSelected, setSettingSelected] = useState('');
  const [settingLabel, setSettingLabel] = useState('');
  const [showModal, setShowModal] = useState(false)

  const closeList = () => {
    setShowList(true)
  }

  const closeModal = () => {
    setShowModal(false)
  }

  const openSuccessModal = () => {
    setShowModal(true)
  }

  return (
    <Container 
      maxWidth='md'
      sx={{ alignItems: "flex-end", marginBottom: '40px' }}
    >
      {
        showList ?
          <SettingsList 
            setShowList={setShowList} 
            setSettingSelected={setSettingSelected} 
            setSettingLabel={setSettingLabel} 
            storeList={storeList}
          />
        :
          <SettingsItem 
            onClose={closeList} 
            settingSelected={settingSelected} 
            settingLabel={settingLabel} 
            storeList={storeList}
            openSuccessModal={openSuccessModal}
          />
      }

      {
        showModal && (
          <Dialog
            sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435, backgroundColor: '#edf7ed', color: '#1e4620', fontWeight: 400 } }}
            maxWidth="xs"
            open={showModal}
          >
            <DialogContent sx={{display: 'flex', alignItems: 'center'}}>
              <CheckCircleOutline fontSize='large' sx={{mr: 2}}/>
              Your selection has been saved.
            </DialogContent>
            <DialogActions>
              <Button onClick={closeModal} autoFocus sx={{color: '#1e4620'}}>
                Close
              </Button>
            </DialogActions>
          </Dialog>
        )
      }

    </Container>
  );
};

export default Settings;
